import { useMutation } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import useToast from "../useToast";

export const useUpdateLeagueChatUrl = () => {
  const { getAccessTokenSilently } = useAuth0();
  const toast = useToast();
  const apiUrl = process.env.REACT_APP_API_URL;

  return useMutation(
    async ({ leagueId, leagueChatUrl }) => {
      const token = await getAccessTokenSilently();

      const response = await axios.put(
        `${apiUrl}/api/league/${leagueId}/add-chat-url`, // Ensure this URL matches your backend route
        { leagueChatUrl },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    },
    {
      onSuccess: (data) => {
        toast.success("League chat URL updated successfully!");
      },
      onError: (error) => {
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred updating league chat URL.";
        toast.error(errorMessage);
        console.error("Error updating league chat URL:", errorMessage);
      },
    }
  );
};
